import type { ContextMenuItem } from '@jet-app/music-classical/intents/context-menu/types';
import type { ActionModel } from '@jet/environment/types/models';

export interface ContextualMenuFetchAction extends ActionModel {
    $kind: 'contextualMenuFetchAction';
    url: string;
    explicitItems?: ContextMenuItem[];
}

export function makeContextualMenuFetchAction(
    url: string,
    explicitItems: ContextMenuItem[] = [],
): ContextualMenuFetchAction {
    const action: ContextualMenuFetchAction = {
        $kind: 'contextualMenuFetchAction',
        url,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };

    if (explicitItems?.length > 0) {
        action.explicitItems = explicitItems;
    }

    return action;
}
